export default __webpack_public_path__ + "static/media/Space key.2613e065.svg";